import { type RefObject, useEffect } from 'react'

/**
 * Fecha um elemento flutuante (popup, dropdown) quando o usuário clica fora
 * dele. O listener só é registrado enquanto `ativo` for verdadeiro.
 */
export function useFecharAoClicarFora(
  referencia: RefObject<HTMLElement>,
  ativo: boolean,
  aoFechar: () => void
): void {
  useEffect(() => {
    if (!ativo) return

    function aoClicarParaFora(evento: MouseEvent): void {
      if (
        referencia.current &&
        !referencia.current.contains(evento.target as Node)
      ) {
        aoFechar()
      }
    }

    document.addEventListener('mousedown', aoClicarParaFora, true)

    return () => {
      document.removeEventListener('mousedown', aoClicarParaFora, true)
    }
  }, [referencia, ativo, aoFechar])
}
